import { render } from "./DownloadInscriptions.vue?vue&type=template&id=78b4c11e"
import script from "./DownloadInscriptions.vue?vue&type=script&lang=js"
export * from "./DownloadInscriptions.vue?vue&type=script&lang=js"

import "./DownloadInscriptions.vue?vue&type=style&index=0&id=78b4c11e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__